"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatRelativeTime = formatRelativeTime;
function formatRelativeTime(isoDate, now) {
    if (now === void 0) { now = new Date(); }
    var MINUTE_MS = 60 * 1000;
    var HOUR_MS = 60 * MINUTE_MS;
    var DAY_MS = 24 * HOUR_MS;
    var MAX_CLOCK_SKEW_MS = 5 * MINUTE_MS;
    var elapsedMs = now.getTime() - new Date(isoDate).getTime();
    if (Number.isNaN(elapsedMs)) {
        return "—";
    }
    // Clock skew can put a fresh reading slightly in the future; treat it as now rather than "in 2 minutes".
    // Anything further ahead is a bad device clock, and hiding it would make a stale device look fresh.
    if (elapsedMs < -MAX_CLOCK_SKEW_MS) {
        return "—";
    }
    if (elapsedMs < MINUTE_MS) {
        return "just now";
    }
    var formatter = new Intl.RelativeTimeFormat("en", { numeric: "always" });
    if (elapsedMs < HOUR_MS) {
        return formatter.format(-Math.floor(elapsedMs / MINUTE_MS), "minute");
    }
    if (elapsedMs < DAY_MS) {
        return formatter.format(-Math.floor(elapsedMs / HOUR_MS), "hour");
    }
    return formatter.format(-Math.floor(elapsedMs / DAY_MS), "day");
}
